export default __webpack_public_path__ + "static/media/speedlimit20.active.860656cf.svg";